import Imatge from 'components/3catinfo/Imatge';
import __isEmpty from 'lodash/isEmpty';

const mergeAgrupacionsTags = ({ agrupacions, tags }) => {
    const arrAgrupacions = Array.isArray(agrupacions) ? agrupacions : [];
    const arrTags = Array.isArray(tags) ? tags : [];
    return [...arrTags, ...arrAgrupacions];
};

const EtiquetesEspecial = (props) => {
    const { id } = props;
    const arrEtiquetes = mergeAgrupacionsTags(props);
    const etiquetes = [
        {
            id: ['GENERALS23J', 'ELECGENER23J'],
            imatge: 'https://statics.3cat.cat/recursos/3catinfo/img/eleccions/eleccions-generals-23j-2023/logo23j.png',
            estil: 'eleccions23j'
        },
        {
            id: ['ELECCIONS29N', 'ELEC29N2026'],
            imatge: 'https://statics.3cat.cat/recursos/3catinfo/img/eleccions/eleccions-generals-29n-2026/logo29n.png',
            estil: 'eleccions29n'
        }
    ];

    const etiquetaItem = etiquetes.find((etiqueta) => arrEtiquetes?.some((item) => etiqueta.id.includes(item.id)));

    if (!__isEmpty(etiquetaItem)) {
        return (
            <div data-testid={`etiqueta-especial-${etiquetaItem.id[0]}`}>
                <Imatge src={etiquetaItem.imatge} layout='fill' className={etiquetaItem.estil} />
            </div>
        );
    } else {
        return <></>;
    }
};

export default EtiquetesEspecial;
